export default "__VITE_ASSET__CDeS9sAU__"